import { QueryClient } from '@tanstack/react-query';

/**
 * Read-only view of a React Query client, just the cache-read surface needed by
 * callers that can't use hooks (Redux thunks, plain helpers).
 */
export interface ReadableQueryClient {
  getQueryData?: (queryKey: readonly unknown[]) => unknown;
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
  },
});

export default queryClient;
